import { createContext } from 'react'

type Props = {
  isFaqPage?: boolean
  isLandingPage?: boolean
}

export const PageLayoutTypeContext = createContext<Props>({
  isFaqPage: false,
  isLandingPage: false,
})
